import { MorphTargetsData } from '~/types';

export type ExpressionType =
  | 'neutral'
  | 'happy'
  | 'angry'
  | 'sad'
  | 'fear'
  | 'love'
  | 'disgust';

type Expression = { [key: string]: { morphTargets: MorphTargetsData } };

export const expression: Expression = {
  neutral: {
    morphTargets: { eyesLookDown: [0.1] },
  },
  happy: {
    morphTargets: {
      browInnerUp: [0.6],
      jawOpen: [0.1],
      mouthDimpleLeft: [0.2],
      mouthDimpleRight: [0.2],
      mouthOpen: [0.3],
      mouthPressLeft: [0.3],
      mouthPressRight: [0.3],
      mouthRollLower: [0.4],
      mouthShrugUpper: [0.4],
      mouthSmile: [0.7],
      mouthUpperUpLeft: [0.3],
      mouthUpperUpRight: [0.3],
      noseSneerLeft: [0.4],
      noseSneerRight: [0.4],
    },
  },
  angry: {
    morphTargets: {
      eyesLookDown: [0.1],
      browDownLeft: [0.6],
      browDownRight: [0.6],
      jawForward: [0.3],
      mouthFrownLeft: [0.7],
      mouthFrownRight: [0.7],
      mouthRollLower: [0.2],
      mouthShrugLower: [0.3],
      handFistLeft: [1],
      handFistRight: [1],
    },
  },
  sad: {
    morphTargets: {
      eyesLookDown: [0.2],
      browDownRight: [0.1],
      browInnerUp: [0.6],
      browOuterUpRight: [0.2],
      eyeSquintLeft: [0.7],
      eyeSquintRight: [0.7],
      mouthFrownLeft: [0.8],
      mouthFrownRight: [0.8],
      mouthLeft: [0.2],
      mouthPucker: [0.5],
      mouthRollLower: [0.2],
      mouthRollUpper: [0.2],
      mouthShrugLower: [0.2],
      mouthShrugUpper: [0.2],
      mouthStretchLeft: [0.4],
    },
  },
  fear: {
    morphTargets: {
      browInnerUp: [0.7],
      eyeSquintLeft: [0.5],
      eyeSquintRight: [0.5],
      eyeWideLeft: [0.6],
      eyeWideRight: [0.6],
      mouthClose: [0.1],
      mouthFunnel: [0.3],
      mouthShrugLower: [0.5],
      mouthShrugUpper: [0.5],
    },
  },
  disgust: {
    morphTargets: {
      browDownLeft: [0.7],
      browDownRight: [0.1],
      browInnerUp: [0.3],
      eyeSquintLeft: [1],
      eyeSquintRight: [1],
      eyeWideLeft: [0.5],
      eyeWideRight: [0.5],
      eyesRotateX: [0.05],
      mouthLeft: [0.4],
      mouthPressLeft: [0.3],
      mouthRollLower: [0.3],
      mouthShrugLower: [0.3],
      mouthShrugUpper: [0.8],
      mouthUpperUpLeft: [0.3],
      noseSneerLeft: [1],
      noseSneerRight: [0.7],
    },
  },
  love: {
    morphTargets: {
      browInnerUp: [0.4],
      browOuterUpLeft: [0.2],
      browOuterUpRight: [0.2],
      mouthSmile: [0.2],
      eyeBlinkLeft: [0.6],
      eyeBlinkRight: [0.6],
      eyeWideLeft: [0.7],
      eyeWideRight: [0.7],
      headRotateX: [0.1],
      mouthDimpleLeft: [0.1],
      mouthDimpleRight: [0.1],
      mouthPressLeft: [0.2],
      mouthShrugUpper: [0.2],
      mouthUpperUpLeft: [0.1],
      mouthUpperUpRight: [0.1],
    },
  },
};
